import { useState } from 'react'

import Audio from './Audio'
import MainSlider from './MainSlider'
import { MAX_REGULAR_THUMBS } from './utils'
import Thumb from './Thumb'
import ThumbSlider from './ThumbSlider'
import Video from './Video'
import type { SliderCommonProps } from '../../../shared/Module'

export default function Photos({ slides }: SliderCommonProps) {
  const [mainSlider, setSlider] = useState<any>(null)
  const [subSlider, setSubSlider] = useState<any>(null)
  const [mainSlide, trackMainSlideForManualThumbs] = useState(0)

  return (
    <div className='c-glide--active'>
      <MainSlider
        arrowsImageURL={arrowsImageURL}
        currentSlideIndex={mainSlide}
        onChange={trackMainSlideForManualThumbs}
        sliderRef={setSlider}
        slides={slides}
        subSliderRef={subSlider}
      />
    </div>
  )
}
